import { Tag } from '@/components/tag/tag'

interface Props {
  tags?: string[] | null
}

export const CellContentTags = ({ tags }: Props) => {
  if (!tags || tags.length === 0) {
    return '-'
  }

  return (
    <div className="mt-0.5 flex flex-wrap gap-x-[7px] gap-y-1">
      {tags.map((tag) => (
        <Tag key={tag}>{tag}</Tag>
      ))}
    </div>
  )
}
